import { useState, useEffect, useMemo } from "react";
import { useAuth } from "./AuthContext";
import { dbFetchSubscribers } from "./supabase";

const fmt     = (n) => "₹" + Number(n||0).toLocaleString("en-IN");
const fmtDate = (d) => d ? new Date(d).toLocaleDateString("en-IN",{day:"2-digit",month:"short",year:"numeric"}) : "—";

const genInvoiceNo = (providerId, subscriberId) => {
  const ts  = Date.now().toString().slice(-6);
  const pid = (providerId||"XX").slice(-2).toUpperCase();
  return `INV${pid}${ts}`;
};

const buildInvoiceHTML = (provider, subscriber, invoiceNo, date) => {
  const subtotal = Number(subscriber.amount) || 0;
  const total    = subtotal;
  return `<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8"/>
<title>Invoice ${invoiceNo}</title>
<style>
  *{box-sizing:border-box;margin:0;padding:0}
  body{font-family:'Segoe UI',Arial,sans-serif;font-size:13px;color:#1a1a1a;background:#fff;padding:36px}
  body::before{content:'PAID';position:fixed;top:50%;left:50%;transform:translate(-50%,-50%) rotate(-35deg);font-size:110px;font-weight:900;color:rgba(37,99,235,0.12);white-space:nowrap;letter-spacing:10px;pointer-events:none;z-index:0;font-family:'Segoe UI',Arial,sans-serif}
  .wrap{position:relative;z-index:1}
  .hdr{display:flex;justify-content:space-between;align-items:flex-start;padding-bottom:18px;border-bottom:2.5px solid #1a1a1a;margin-bottom:22px}
  .biz-name{font-size:24px;font-weight:800;color:#1a1a1a;margin-bottom:5px}
  .biz-info{font-size:12px;color:#555;line-height:1.8}
  .inv-block{text-align:right}
  .inv-word{font-size:30px;font-weight:900;color:#2563EB;letter-spacing:2px}
  .inv-meta{font-size:12px;color:#555;margin-top:6px;line-height:1.9}
  .inv-meta strong{color:#1a1a1a}
  .bill-row{display:flex;gap:48px;margin-bottom:22px}
  .bill-box h4{font-size:10px;font-weight:700;color:#999;text-transform:uppercase;letter-spacing:.07em;margin-bottom:7px}
  .bill-box .val{font-size:15px;font-weight:700;color:#1a1a1a;margin-bottom:3px}
  .bill-box .sub{font-size:12px;color:#555;line-height:1.7}
  table{width:100%;border-collapse:collapse;margin-bottom:0}
  thead tr{background:#2563EB}
  thead th{padding:11px 14px;text-align:left;font-size:12px;font-weight:700;color:#fff;letter-spacing:.04em}
  thead th:nth-child(2){text-align:center}
  thead th:nth-child(3),thead th:nth-child(4){text-align:right}
  tbody tr{border-bottom:1px solid #f0f0f0}
  tbody td{padding:13px 14px;font-size:13px;color:#1a1a1a}
  tbody td:nth-child(2){text-align:center}
  tbody td:nth-child(3),tbody td:nth-child(4){text-align:right;font-weight:500}
  .totals-section{border-top:1.5px solid #e5e5e5}
  .totals-section tr td{padding:8px 14px;font-size:13px}
  .totals-section tr td:first-child{color:#666}
  .totals-section tr td:last-child{text-align:right;font-weight:500}
  .total-final td{background:#2563EB;color:#fff!important;font-size:16px;font-weight:800;padding:13px 14px!important}
  .total-final td:last-child{text-align:right!important}
  .footer{margin-top:30px;padding-top:14px;border-top:1px solid #eee;font-size:11px;color:#aaa;text-align:center;line-height:1.8}
  @media print{body{padding:20px}body::before{position:fixed}}
</style>
</head>
<body>
<div class="wrap">
  <div class="hdr">
    <div>
      <div class="biz-name">${provider.name||""}</div>
      <div class="biz-info">
        ${provider.owner ? provider.owner+"<br/>" : ""}
        ${provider.city  ? provider.city+"<br/>"  : ""}
        ${provider.whatsapp ? "📞 "+String(provider.whatsapp).replace(/^91/,"") : ""}
      </div>
    </div>
    <div class="inv-block">
      <div class="inv-word">INVOICE</div>
      <div class="inv-meta">
        <strong>Invoice #</strong> ${invoiceNo}<br/>
        <strong>Date</strong> ${date}
      </div>
    </div>
  </div>
  <div class="bill-row">
    <div class="bill-box">
      <h4>Bill To</h4>
      <div class="val">${subscriber.name||""}</div>
      <div class="sub">${subscriber.phone||""}</div>
      ${subscriber.email ? `<div class="sub">${subscriber.email}</div>` : ""}
      ${subscriber.deliveryArea ? `<div class="sub">📍 ${subscriber.deliveryArea}</div>` : ""}
    </div>
    <div class="bill-box">
      <h4>Plan Details</h4>
      <div class="val">${subscriber.plan||""} · ${subscriber.type||""}</div>
      <div class="sub">Start: ${fmtDate(subscriber.startDate)}</div>
      <div class="sub">End: ${fmtDate(subscriber.endDate)}</div>
    </div>
  </div>
  <table>
    <thead>
      <tr>
        <th>Description</th><th>Qty</th><th>Rate</th><th>Amount</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>${subscriber.plan||""} ${subscriber.type||""} Meal Subscription</td>
        <td>1</td><td>${fmt(subtotal)}</td><td>${fmt(subtotal)}</td>
      </tr>
    </tbody>
    <tbody class="totals-section">
      <tr><td>Subtotal</td><td colspan="3">${fmt(subtotal)}</td></tr>
      <tr><td>Discount</td><td colspan="3">₹0</td></tr>
    </tbody>
    <tfoot>
      <tr class="total-final">
        <td colspan="3">TOTAL AMOUNT</td><td>${fmt(total)}</td>
      </tr>
    </tfoot>
  </table>
  <div class="footer">
    Thank you for your business with ${provider.name||"us"}!<br/>
    This is a computer-generated invoice.
  </div>
</div>
</body>
</html>`;
};

const STATUS_STYLE = {
  Active:   { bg:"#EAF3DE", color:"#27500A" },
  Pending:  { bg:"#FAEEDA", color:"#633806" },
  Overdue:  { bg:"#FCEBEB", color:"#791F1F" },
  Paused:   { bg:"#E6F1FB", color:"#0C447C" },
  Inactive: { bg:"#F1EFE8", color:"#5F5E5A" },
};

export default function Billing({ userId = "default" }) {
  const { user } = useAuth();
  const [subscribers, setSubscribers] = useState([]);
  const [loading,      setLoading]     = useState(true);
  const [search,       setSearch]      = useState("");
  const [filterStatus, setFilterStatus]= useState("All");
  const [generating,   setGenerating]  = useState(null);
  const [provider,     setProvider]    = useState(null);

  useEffect(() => {
    if (!user) return;
    import("./supabase").then(({ supabase }) => {
      supabase.from("mealbox_users").select("*").eq("id", userId).single()
        .then(({ data }) => { if (data) setProvider(data); });
    });
    dbFetchSubscribers(userId)
      .then(data => { setSubscribers(data); setLoading(false); })
      .catch(() => setLoading(false));
  }, [userId, user]);

  const filtered = useMemo(() => {
    let list = subscribers.filter(s => s.status !== "Inactive");
    const q = search.toLowerCase();
    if (q) list = list.filter(s =>
      s.name.toLowerCase().includes(q) || (s.phone||"").includes(q)
    );
    if (filterStatus !== "All") list = list.filter(s => s.status === filterStatus);
    return list.sort((a,b) => a.name.localeCompare(b.name));
  }, [subscribers, search, filterStatus]);

  const stats = useMemo(() => ({
    total:   subscribers.filter(s => s.status !== "Inactive").length,
    revenue: subscribers.filter(s => s.status === "Active").reduce((a,s) => a+(s.amount||0), 0),
    overdue: subscribers.filter(s => s.status === "Overdue").length,
  }), [subscribers]);

  const generateInvoice = (subscriber) => {
    setGenerating(subscriber.id);
    const invoiceNo = genInvoiceNo(userId, subscriber.id);
    const date      = new Date().toLocaleDateString("en-IN",{day:"2-digit",month:"short",year:"numeric"});
    const prov      = provider || { name: user?.name||"", city: user?.city||"", owner: user?.owner||"", whatsapp:"" };
    const html      = buildInvoiceHTML(prov, subscriber, invoiceNo, date);

    const win = window.open("","_blank");
    if (win) {
      win.document.write(html);
      win.document.close();
      setTimeout(() => { try { win.print(); } catch(e){} }, 900);
    }

    const phone  = (subscriber.phone||"").replace(/\D/g,"");
    const fullPh = phone.startsWith("91") ? phone : `91${phone}`;
    const msg    = encodeURIComponent(
      `Hi ${subscriber.name.split(" ")[0]}! 👋\n\n` +
      `Your invoice is ready.\n\n` +
      `📋 Invoice #: ${invoiceNo}\n` +
      `📅 Date: ${date}\n` +
      `💰 Amount: ${fmt(subscriber.amount)}\n` +
      `📦 Plan: ${subscriber.plan} ${subscriber.type}\n\n` +
      `Thank you for choosing ${prov.name||"us"}! 🙏`
    );

    setTimeout(() => {
      window.open(`https://wa.me/${fullPh}?text=${msg}`, "_blank");
      setGenerating(null);
    }, 1400);
  };

  if (loading) return (
    <div className="page-wrap" style={{fontFamily:"'DM Sans','Segoe UI',sans-serif",background:"#F7F6F2",minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center"}}>
      <div style={{color:"#78716C",fontSize:13}}>Loading billing…</div>
    </div>
  );

  return (
    <div className="page-wrap" style={{fontFamily:"'DM Sans','Segoe UI',sans-serif",background:"#F7F6F2",minHeight:"100vh"}}>
      <div className="page-header" style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:"1.5rem"}}>
        <div>
          <h1 style={{fontSize:22,fontWeight:600,letterSpacing:"-0.02em",margin:0}}>Billing</h1>
          <p style={{fontSize:13,color:"#78716C",margin:"4px 0 0"}}>Generate and send invoices to your customers</p>
        </div>
      </div>

      <div className="stat-grid-4" style={{marginBottom:"1.5rem"}}>
        {[
          { label:"Total customers", value: stats.total         },
          { label:"Active revenue",  value: fmt(stats.revenue)  },
          { label:"Overdue",         value: stats.overdue, warn: stats.overdue > 0 },
          { label:"Showing",         value: filtered.length     },
        ].map(c => (
          <div key={c.label} style={{background:c.warn?"#FCEBEB":"#FFF",border:`0.5px solid ${c.warn?"#F09595":"#E7E5E0"}`,borderRadius:12,padding:"1rem 1.25rem"}}>
            <div style={{fontSize:12,color:c.warn?"#A32D2D":"#78716C",marginBottom:6}}>{c.label}</div>
            <div style={{fontSize:24,fontWeight:600,color:c.warn?"#A32D2D":"#1C1917"}}>{c.value}</div>
          </div>
        ))}
      </div>

      <div className="filter-row" style={{display:"flex",gap:8,marginBottom:"1rem",flexWrap:"wrap",alignItems:"center"}}>
        <input value={search} onChange={e=>setSearch(e.target.value)}
          placeholder="Search by name or phone…"
          style={{flex:"1 1 180px",padding:"7px 12px",fontSize:13,borderRadius:8,border:"0.5px solid #E7E5E0",background:"#FFF",outline:"none"}}/>
        <select value={filterStatus} onChange={e=>setFilterStatus(e.target.value)}
          style={{padding:"7px 10px",fontSize:13,borderRadius:8,border:"0.5px solid #E7E5E0",background:"#FFF",outline:"none",cursor:"pointer"}}>
          {["All","Active","Pending","Paused","Overdue"].map(s=><option key={s}>{s}</option>)}
        </select>
      </div>

      <div className="sub-table-wrap" style={{background:"#FFF",borderRadius:12,border:"0.5px solid #E7E5E0",overflowX:"auto"}}>
        <table className="sub-table" style={{width:"100%",borderCollapse:"collapse",fontSize:13,minWidth:800}}>
          <thead>
            <tr style={{background:"#F7F6F2",borderBottom:"0.5px solid #E7E5E0"}}>
              {["Customer","Phone","Plan","Type","Amount","Start Date","End Date","Status","Action"].map(h=>(
                <th key={h} style={{padding:"10px 14px",textAlign:"left",fontWeight:500,fontSize:12,color:"#78716C",whiteSpace:"nowrap"}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && (
              <tr><td colSpan={9} style={{padding:"3rem",textAlign:"center",color:"#A8A29E"}}>
                {subscribers.length === 0 ? "No subscribers yet" : "No results found"}
              </td></tr>
            )}
            {filtered.map((s, i) => {
              const st    = STATUS_STYLE[s.status] || STATUS_STYLE.Pending;
              const isGen = generating === s.id;
              return (
                <tr key={s.id} style={{borderBottom:i<filtered.length-1?"0.5px solid #F3F2EE":"none"}}>
                  <td style={{padding:"11px 14px"}}>
                    <div style={{fontWeight:500,color:"#1C1917"}}>{s.name}</div>
                    <div style={{fontSize:11,color:"#A8A29E"}}>{s.email||""}</div>
                  </td>
                  <td style={{padding:"11px 14px",color:"#78716C",fontSize:12}}>{s.phone}</td>
                  <td style={{padding:"11px 14px",color:"#44403C"}}>{s.plan}</td>
                  <td style={{padding:"11px 14px",color:"#44403C"}}>{s.type}</td>
                  <td style={{padding:"11px 14px",fontWeight:600,color:"#1C1917"}}>{fmt(s.amount)}</td>
                  <td style={{padding:"11px 14px",fontSize:12,color:"#78716C",whiteSpace:"nowrap"}}>{fmtDate(s.startDate)}</td>
                  <td style={{padding:"11px 14px",fontSize:12,color:"#78716C",whiteSpace:"nowrap"}}>{fmtDate(s.endDate)}</td>
                  <td style={{padding:"11px 14px"}}>
                    <span style={{fontSize:11,fontWeight:500,padding:"3px 10px",borderRadius:20,background:st.bg,color:st.color}}>{s.status}</span>
                  </td>
                  <td style={{padding:"11px 14px"}}>
                    <button onClick={()=>generateInvoice(s)} disabled={isGen||!s.phone}
                      style={{
                        display:"flex",alignItems:"center",gap:5,
                        padding:"7px 14px",fontSize:12,fontWeight:500,borderRadius:8,border:"none",
                        cursor:isGen||!s.phone?"default":"pointer",
                        background:isGen?"#78716C":!s.phone?"#F1EFE8":"#25D366",
                        color:!s.phone?"#A8A29E":"#FFF",whiteSpace:"nowrap",
                      }}>
                      {isGen ? "⏳ Sending…" : !s.phone ? "No phone" : "🧾 Generate & Send"}
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div style={{marginTop:14,padding:"10px 14px",background:"#E6F1FB",borderRadius:8,fontSize:12,color:"#0C447C",lineHeight:1.6}}>
        ℹ️ <strong>"Generate & Send"</strong> opens your invoice (save as PDF via <em>Ctrl+P → Save as PDF</em>), then opens WhatsApp with a pre-written message to the customer.
      </div>
    </div>
  );
}
